/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Action_CancelInputs */

const vi_stocktake_action_cancel = /** @type {(inputs: Stocktake_Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy phiếu`)
};

/**

* @param {Stocktake_Action_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_action_cancel = /** @type {((inputs?: Stocktake_Action_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Action_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_action_cancel(inputs)
});